import { render, staticRenderFns } from "./LeaveRetracted.vue?vue&type=template&id=20d15c86"
import script from "./LeaveRetracted.vue?vue&type=script&lang=js"
export * from "./LeaveRetracted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports